module.exports = __webpack_public_path__ + "img/kamalp.07a50453.webp";